import React, { useState } from 'react';

import styled from 'styled-components';

import useProductGridData from '../../hooks/useProductGridData';
import {
  getAllCioFacetsWithSelectedUrlFilters,
  groupSizeFacets,
} from '../../utils/filters';

import DesktopGridFilterRenderer from './DesktopGridFilterRenderer';
import DesktopGridSelectedFilters from './DesktopGridSelectedFilters';

const DesktopGridFacetList = styled.ul`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${({ theme }) => theme.colors.gridFacetListBorderColor};
  list-style: none;
`;

const FacetListItem = styled.li`
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.gridFacetListBorderColor};

  &:last-child {
    border-bottom: none;
  }
`;

const DesktopGridFilters = () => {
  const { cioFacets, selectedUrlFilters, allCioFacets } = useProductGridData();
  const [openPanels, setOpenPanels] = useState({});

  const selectedCioFacets = getAllCioFacetsWithSelectedUrlFilters({
    selectedUrlFilters,
    allCioFacets,
    cioFacets,
  });

  const facetsWithSizesGrouped = groupSizeFacets(selectedCioFacets);

  const togglePanel = (panelId) => {
    setOpenPanels((prevState) => ({
      ...prevState,
      [panelId]: !prevState[panelId],
    }));
  };

  const closeAllPanels = () => {
    setOpenPanels({});
  };

  // TODO: add max 7 facets when on search page

  return (
    <>
      <DesktopGridSelectedFilters closeAllPanels={closeAllPanels} />
      <DesktopGridFacetList>
        {facetsWithSizesGrouped?.map((facet) => (
          <FacetListItem key={facet?.name || facet?.display_name}>
            <DesktopGridFilterRenderer
              facet={facet}
              togglePanel={togglePanel}
              openPanels={openPanels}
            />
          </FacetListItem>
        ))}
      </DesktopGridFacetList>
    </>
  );
};

export default DesktopGridFilters;
